import { render } from "./ViewsAcknowledgement.vue?vue&type=template&id=7d0a5859"
import script from "./ViewsAcknowledgement.vue?vue&type=script&lang=js"
export * from "./ViewsAcknowledgement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__